import * as vp from 'vopay';
import { ReactNode, createContext, useContext } from 'react';
import useFetchPartnerInvoiceDetails from '../hooks/useApi/useFetchPartnerInvoiceDetails';

import type { PartnerInvoiceDetailsRequestParams } from '../hooks/useApi/useFetchPartnerInvoiceDetails';

type InvoiceDetailsCtx = {
  invoiceDetails: vp.PartnerInvoiceDetailsInvoiceDetails | undefined;
  invoicePeriod: vp.PartnerInvoiceDetailsInvoicePeriod | undefined;
  refreshInvoiceDetails: (requestParams: PartnerInvoiceDetailsRequestParams, options?: { useCache: boolean }) => void;
};

export const InvoiceDetailsContext = createContext<InvoiceDetailsCtx>({
  invoiceDetails: {},
  invoicePeriod: { FromDate: '', ToDate: '' },
  refreshInvoiceDetails: () => {},
});

export const InvoiceDetailsProvider = ({ children }: { children: ReactNode }): React.JSX.Element => {
  const [response, refreshInvoiceDetails] = useFetchPartnerInvoiceDetails({});

  return (
    <InvoiceDetailsContext.Provider
      value={{
        invoiceDetails: response?.invoiceDetails,
        invoicePeriod: response?.invoicePeriod,
        refreshInvoiceDetails,
      }}
    >
      {children}
    </InvoiceDetailsContext.Provider>
  );
};

export const useInvoiceDetails = (): InvoiceDetailsCtx => useContext(InvoiceDetailsContext);
